<!-- <div class="white container-fluid p-0"> -->
  <!-- <app-header [title]="title"></app-header> -->
  <div class="lock-screen vh-scroll">
    <div class="animate fadeIn text-center lock-c">
      <form [formGroup]="ResetPasswordForm" (ngSubmit)="ResetPassword()">
        <div class="col-md-12">
          <!-- <span class="font-24">iAR</span> -->
          <img src="assets/images/iAR.png">
        </div>

        <div class="col-md-12 mt-20">
          <div class="form-group">
            <label for="oldpass" class="label-std control-label p-0 b-600">Old Password</label>
            <input [minlength]="emailMinLength" [maxlength]="emailMaxLength" type="password" formControlName="Old_Password" class="form-control"
              id="oldpass" placeholder="Old Password" value="">
            <div class="error" *ngIf="ResetPasswordForm.get('Old_Password').hasError('required') && DisplayError">
              Old Password is required.
            </div>
            <div class="error"
              *ngIf="!ResetPasswordForm.controls['Old_Password'].valid && ResetPasswordForm.controls['Old_Password'].dirty">
              Old Password should be of {{emailMinLength}} to {{emailMaxLength}} characters only
            </div>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="form-group">
            <label for="newpass" class="label-std control-label p-0 b-600">New Password</label>
            <input [minlength]="emailMinLength" [maxlength]="emailMaxLength" type="password" formControlName="New_Password" class="form-control"
              id="newpass" placeholder="New Password" value="">
            <div class="error" *ngIf="ResetPasswordForm.get('New_Password').hasError('required') && DisplayError">
              New Password is required.
            </div>
            <!-- <div class="error" *ngIf="ResetPasswordForm.controls['New_Password'].hasError('minlength') && ResetPasswordForm.controls['New_Password'].dirty">
              New Password should be of 8 to 20 characters only
            </div> -->
            <div class="error"
              *ngIf="ResetPasswordForm.controls['New_Password'].hasError('pattern') && ResetPasswordForm.controls['New_Password'].dirty">
              New Password should be of {{emailMinLength}} to {{emailMaxLength}} characters and must contain 1 capital,1 small,1 special and 1 digit
              character
            </div>
            <div class="error"
              *ngIf="ResetPasswordForm.get('New_Password').hasError('notMatch') && ResetPasswordForm.controls['New_Password'].dirty">
              New Password should not be as same as old password
            </div>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="form-group">
            <label for="confirmnewpass" class="label-std control-label p-0 b-600">Confirm New Password</label>
            <input [minlength]="emailMinLength" [maxlength]="emailMaxLength" type="password" formControlName="confirmnewpass" class="form-control" id="confirmnewpass"
              placeholder="Confirm New Password" value="">
            <div class="error"
              *ngIf="ResetPasswordForm.get('confirmnewpass').hasError('notMatch') && ResetPasswordForm.controls['confirmnewpass'].dirty">
              New Password and Confirm Password do not match
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-10" *ngIf="ResetPasswordForm.controls.captchaData as captcha">
          <div class="form-group" style="margin-bottom:0">
            <div class="captchaContainer">
              <img [src]="showCaptcha" alt="captcha" style="height: 50px;width: 200px;">
              <div class="controls">
                <div class="inputCtrl">
                  <input class="valid" formControlName="captchaData" type="text" placeholder="Type above text">
                  <span class="errorSection" *ngIf="captcha.touched==true || DisplayError">
                    <div class="error" *ngIf="ResetPasswordForm.get('captchaData').hasError('required') && DisplayError">
                      Captcha is required.
                    </div>
                  </span>
                </div>
                <button title="Refresh Captcha Code" type="button" class="btn btn-primary refreshIconAlign" (click)="callCaptcha()">
                  <i [ngClass]="{'rotate': isCaptcha == true}" class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-10 text-left1">
          <button [disabled]="DisableSubmit" class="btn blue square-btn blue-hover btn-txt btn-default">Submit</button>
        </div>
      </form>
    </div>
  </div>
